<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="AI检索" v-if="findChildren(175)!==-1" name="goodsai" style="height: 100%;">
				<goodsai-index />
			</el-tab-pane>
			<el-tab-pane label="知识库" v-if="findChildren(176)!==-1" name="goodsknowledge" style="height: 100%;">
				<goodsknowledge-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import goodsaiIndex from './goodsai/index.vue'
	import goodsknowledgeIndex from './goodsknowledge/index.vue'
	
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
			}
			//this.activeName = 'goodsknowledge'
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			goodsaiIndex,
			goodsknowledgeIndex

		}
	}
</script>